import { createRouter, createWebHistory } from 'vue-router'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'

import store from '@/store'

import Home from '@/views/Home.vue'
import Profile from '@/views/Profile.vue'
import RegisterConfirmation from '@/views/RegisterConfirmation.vue'
import Register from '@/views/Register.vue'
import CompleteConfirmation from '@/views/CompleteConfirmation.vue'
import CompleteRegister from '@/views/CompleteRegister.vue'
import ConfirmEmail from '@/views/ConfirmEmail.vue'
import ConfirmDelete from '@/views/ConfirmDelete.vue'
import ForgotPassword from '@/views/ForgotPassword.vue'
import ResetPassword from '@/views/ResetPassword.vue'
import ChangePassword from '@/views/ChangePassword.vue'
import OidcCallback from '@/views/OidcCallback.vue'
import OidcPopupCallback from '@/views/OidcPopupCallback.vue'
import OidcCallbackError from '@/views/OidcCallbackError.vue'

const routes = [
    {
        path: '/:instance/',
        name: 'Home',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/start/',
        name: 'Start',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/search/',
        name: 'Search',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/part/p/:partuuid',
        name: 'Part',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/part/p/:partuuid/ref/:referer/t/:term',
        name: 'ReferPart',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/part/p/:partuuid/e/:euid',
        name: 'MatchPart',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/part/p/:partuuid/e/:euid/ref/:referer/t/:term',
        name: 'MatchReferPart',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/part/e/:euid',
        name: 'ExternalPart',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/search/keyword/src/:searchtext/p/:page',
        name: 'KeyDefSearch',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/search/keyword/',
        name: 'KeySearch',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/search/pn/src/:searchtext/p/:page',
        name: 'TextPnSearch',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/search/pn/mfr/:searchmanufacturer/p/:page',
        name: 'MfrPnDefSearch',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/search/pn/',
        name: 'MfrPnSearch',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/search/pn/mfr/:searchmanufacturer/src/:searchtext/p/:page',
        name: 'FullPnSearch',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/reference/',
        name: 'ReferenceBase',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/reference/p/:page',
        name: 'ReferencPage',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/reference/mfr/:searchmanufacturers/p/:page',
        name: 'ReferenceMfrPage',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/reference/src/:referencetext/p/:page',
        name: 'ReferenceSearch',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/reference/mfr/:searchmanufacturers/src/:referencetext/p/:page',
        name: 'ReferenceMfrSearch',
        component: Home,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/Profile',
        name: 'Profile',
        component: Profile,
        props: true,
    },
    {
        path: '/:instance/ConfirmDelete',
        name: 'ConfirmDelete',
        component: ConfirmDelete,
        props: true,
    },
    {
        path: '/:instance/ConfirmEmail',
        name: 'ConfirmEmail',
        component: ConfirmEmail,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/Account/Register',
        name: 'Register',
        component: Register,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/Account/RegisterConfirmation',
        name: 'RegisterConfirmation',
        component: RegisterConfirmation,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/CompleteRegister',
        name: 'CompleteRegister',
        component: CompleteRegister,
        props: true
    },
    {
        path: '/:instance/CompleteConfirmation',
        name: 'CompleteConfirmation',
        component: CompleteConfirmation,
        props: true
    },
    {
        path: '/:instance/Account/ForgotPassword',
        name: 'ForgotPassword',
        component: ForgotPassword,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/ResetPassword',
        name: 'ResetPassword',
        component: ResetPassword,
        props: true,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/:instance/Account/ChangePassword',
        name: 'ChangePassword',
        component: ChangePassword,
        props: true
    },
    {
        path: '/oidc-callback', // Needs to match redirectUri in you oidcSettings
        name: 'oidcCallback',
        component: OidcCallback,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/oidc-popup-callback', // Needs to match popupRedirectUri in you oidcSettings
        name: 'oidcPopupCallback',
        component: OidcPopupCallback,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/signin-oidc-error', // Needs to match redirect_uri in you oidcSettings
        name: 'oidcCallbackError',
        component: OidcCallbackError,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/oidc-callback-error', // Needs to match redirect_uri in you oidcSettings
        name: 'oidcCallbackError',
        component: OidcCallbackError,
        meta: {
            isPublic: true
        }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_BASE_URL),
    base: process.env.VUE_APP_BASE_URL,
    routes
})

router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'))

export default router
